import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { LOGO } from "@/lib/assets";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-obsidian text-cream relative grain flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="relative z-10 w-full max-w-sm">
        <img src={LOGO} alt="HairPrive" className="h-32 w-auto object-contain mx-auto" style={{ filter: "brightness(0) invert(1)" }} />
        <p className="mt-2 text-center font-sans uppercase tracking-[0.35em] text-[10px] text-cream/50">Admin Portal</p>
        <form onSubmit={submit} className="mt-12 space-y-4">
          <Input data-testid="admin-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none bg-transparent border-cream/25 h-12 text-cream placeholder:text-cream/40" />
          <Input data-testid="admin-password" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none bg-transparent border-cream/25 h-12 text-cream placeholder:text-cream/40" />
          <button type="submit" disabled={loading} data-testid="admin-login-btn" className="w-full bg-cream text-obsidian py-4 font-sans uppercase tracking-[0.2em] text-xs hover:bg-amber hover:text-cream transition-colors disabled:opacity-50 inline-flex items-center justify-center gap-2">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
